// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18rlT","toggle":"styles_toggle__1l3TS","preview":"styles_preview__1FmLl"};